import * as React from 'react';
import { FaInfo } from 'react-icons/fa';
import { FmcContext } from 'app/infrastructure/push/context';
import { Consent, ConsentPermission, ConsentType, NotificationPermissionType } from 'app/area/user-profile/my-notifications/types';
import styles from './info-messages.scss';
import { getNotificationPermission } from 'app/area/user-profile/my-notifications/notification-permission';

interface InfoMessagesProps {
  permission: ConsentPermission;
  consents: Consent[];
  translation: any;
}

const InfoMessagePanel = (props: { text: string }) => <div className="col-md-12">
  <div className={styles.infoMessagePanel}>
    <FaInfo /> {props.text}
  </div>
</div>;

export const InfoMessages = (props: InfoMessagesProps) => {
  const { permission: { push = false } = {}, consents, translation } = props;

  return (<div className="row">
    {getNotificationPermission() === NotificationPermissionType.Denied
      && <InfoMessagePanel text={translation.consent_push_browser_allow_message} />}
    <FmcContext.Consumer>
      {value => {
        const activePushConsent = consents && consents.find(c => c.type === ConsentType.push && c.value.token === value.state.fmcToken);
        return !activePushConsent && push && <InfoMessagePanel text={translation.consent_push_not_active_message} />;
      }}
    </FmcContext.Consumer>
  </div>);
};
